import React from "react";
import { getRoomMetrics } from "../engine/metrics";

export default function PrintView({ st, boq }) {
  const p     = st.project || {};
  const rooms = Object.keys(st.faces).map(fId => getRoomMetrics(fId, st)).filter(Boolean);

  return (
    <div id="pc-print" style={{ display: "none" }}>
      <style>{`
        @media print {
          #pc-app    { display: none !important }
          #pc-print  { display: block !important; font-family: Arial, sans-serif; padding: 24px; color: #111 }
          .print-table { width: 100%; border-collapse: collapse; margin: 12px 0; font-size: 11px }
          .print-table th { background: #f5f5f5; padding: 6px 10px; text-align: left; border: 1px solid #ddd }
          .print-table td { padding: 5px 10px; border: 1px solid #eee }
          .print-total { font-size: 16px; font-weight: 700; margin: 16px 0; padding: 12px; background: #fff8e0; border: 2px solid #e8a838; border-radius: 6px }
        }
      `}</style>

      <h1 style={{ fontSize: 20, margin: "0 0 4px" }}>{p.name || "Floor Plan"}</h1>
      <div style={{ fontSize: 12, color: "#555", marginBottom: 4 }}>Client: {p.client || "—"}</div>
      <div style={{ fontSize: 12, color: "#555", marginBottom: 16 }}>
        Address: {p.address || "—"} · Date: {p.date || ""}
      </div>
      <hr />

      <h2 style={{ fontSize: 14, margin: "16px 0 8px" }}>Room Schedule</h2>
      <table className="print-table">
        <thead>
          <tr><th>Room</th><th>Type</th><th>Area (m²)</th><th>Floor ₹</th><th>Wall Finish ₹</th><th>Total ₹</th></tr>
        </thead>
        <tbody>
          {rooms.map((r, i) => (
            <tr key={i}>
              <td>{r.rd?.name || r.tmpl.label}</td>
              <td>{r.tmpl.label}</td>
              <td>{r.areaM2.toFixed(2)}</td>
              <td>{Math.round(r.floorCost).toLocaleString("en-IN")}</td>
              <td>{Math.round(r.wallCost).toLocaleString("en-IN")}</td>
              <td><b>{Math.round(r.totalCost).toLocaleString("en-IN")}</b></td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 style={{ fontSize: 14, margin: "16px 0 8px" }}>Bill of Quantities — Walls</h2>
      <table className="print-table">
        <thead>
          <tr><th>Material</th><th>Volume (m³)</th><th>Bricks</th><th>Cement (bags)</th><th>Sand (cft)</th><th>Cost ₹</th></tr>
        </thead>
        <tbody>
          {Object.values(boq.byMat).map((m, i) => (
            <tr key={i}>
              <td>{m.mat.name}</td>
              <td>{m.vol.toFixed(3)}</td>
              <td>{Math.ceil(m.vol * m.mat.bricksPerM3) || "—"}</td>
              <td>{(m.vol * m.mat.cementBagsPerM3).toFixed(1) || "—"}</td>
              <td>{(m.vol * m.mat.sandCftPerM3).toFixed(1) || "—"}</td>
              <td><b>{Math.round(m.cost).toLocaleString("en-IN")}</b></td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 style={{ fontSize: 14, margin: "16px 0 8px" }}>Cost Summary</h2>
      <table className="print-table">
        <tbody>
          <tr><td>Structure (materials)</td><td><b>{Math.round(boq.wallCost).toLocaleString("en-IN")}</b></td></tr>
          <tr><td>Labour (25%)</td>         <td><b>{Math.round(boq.labourCost).toLocaleString("en-IN")}</b></td></tr>
          <tr><td>Finishes (floor + wall)</td><td><b>{Math.round(boq.roomCost).toLocaleString("en-IN")}</b></td></tr>
        </tbody>
      </table>

      <div className="print-total">
        TOTAL PROJECT COST: ₹ {Math.round(boq.totalCost).toLocaleString("en-IN")}
      </div>
      <div style={{ fontSize: 10, color: "#999", marginTop: 24 }}>
        Generated by J.A.D.E v1 · DPL Homestar · {new Date().toLocaleString("en-IN")}
      </div>
    </div>
  );
}
